export const getImageFromGit = async (imagePath: string): Promise<string> => {
    const username = localStorage.getItem('github_username');
    const token = localStorage.getItem('github_token');

    if (!username || !token || !imagePath) return '';

    // Remove leading slash if present
    const cleanPath = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
    const fullPath = `public/${cleanPath}`;

    try {
      // Get the file metadata
      const response = await fetch(
        `https://api.github.com/repos/${username}/agata-sawicka-website-code/contents/${fullPath}`,
        {
          headers: {
            'Authorization': `token ${token}`,
            'Accept': 'application/vnd.github.v3+json'
          }
        }
      );

      if (!response.ok) {
        console.error(`Failed to fetch image metadata: ${imagePath}`);
        return '';
      }

      const data = await response.json();

      let url = '';
      if (data.content == null || data.content.length === 0) {
        url = `https://raw.githubusercontent.com/${username}/agata-sawicka-website/main/${cleanPath}`
      } else {
        // Convert content from base64 to blob URL
        const binary = atob(data.content);
        const array = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          array[i] = binary.charCodeAt(i);
        }

        const blob = new Blob([array], { type: 'image/jpeg' });
        url = URL.createObjectURL(blob);
      }

      return url
    } catch (error) {
      console.error(`Error fetching image: ${imagePath}`, error);
      return ''
    }
  };